<script>
export default {
  props: ['feedGroupIndex', 'feedIndex', 'inputIndex'],
  methods: {
    getInput (key) {
      const feeds = this.$store.state.feeds
      const feedGroup = feeds[this.feedGroupIndex]
      const feed = feedGroup[this.feedIndex]
      const input = feed[this.inputIndex]
      return input[key]
    },
    updateInput (key, value) {
      this.$store.commit({
        type: 'updateInput',
        key: key,
        value: value,
        feedGroupIndex: this.feedGroupIndex,
        feedIndex: this.feedIndex,
        inputIndex: this.inputIndex
      })
    }
  },
  computed: {
    value: {
      get () {
        return this.getInput('value')
      },
      set (value) {
        this.updateInput('value', value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/inputs/Input.vue